import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'

import RetroWindow from '@/components/generals/retro-window'
import ContactForm from '@/components/landing/contact-form'
import PixelEdge from '@/components/pixel/pixel-edge'
import PixelFlower from '@/components/pixel/pixel-flower'
import SkateDino from '@/components/pixel/skate-dino'

import { NEXT_STEPS } from '@/constants/content'

const ContactSection: FC = (): ReactNode => {
    return (
        <section
            id='contacts'
            aria-labelledby='contact-title'
            className='relative mt-12 bg-bubblegum pattern-dots pt-20 pb-28 text-ink md:mt-16 md:pt-28 md:pb-36'
        >
            <PixelEdge color='var(--bubblegum)' seed={31} className='absolute inset-x-0 bottom-[calc(100%-1px)]' />

            <PixelFlower color='var(--ink)' className='pointer-events-none absolute top-16 right-[4%] hidden w-24 animate-spin-slow opacity-20 lg:block' />

            <div className='mx-auto grid max-w-7xl gap-14 px-5 md:px-8 lg:grid-cols-[1fr_1.15fr] lg:gap-16'>
                <div>
                    <p className='font-heading text-lg md:text-xl'>
                        ready to roar?
                    </p>

                    <h2 id='contact-title' className='mt-1 font-heading text-[clamp(3.2rem,10vw,8rem)] leading-[0.85]'>
                        let's start!
                    </h2>

                    <p className='mt-6 max-w-md text-base leading-relaxed font-semibold md:text-lg'>
                        Tell us about your brand and your goals. We will come back with first ideas within one business day.
                    </p>

                    <ol className='mt-10 space-y-4'>
                        {NEXT_STEPS.map((step, index) => (
                            <li key={step} className='flex items-center gap-4'>
                                <span className='grid size-11 shrink-0 place-items-center border-2 border-ink bg-white font-heading text-lg shadow-pixel-sm'>
                                    {index + 1}
                                </span>
                                <span className='text-base font-semibold md:text-lg'>
                                    {step}
                                </span>
                            </li>
                        ))}
                    </ol>

                    <SkateDino interactive firstLine="psst! fill the form" className='mt-24 hidden w-[252px] lg:block' />
                </div>

                <Reveal variant='right'>
                    <RetroWindow title="new_project.exe" tone='ink'>
                        <ContactForm />
                    </RetroWindow>
                </Reveal>
            </div>
        </section>
    )
}

export default ContactSection
